import React, { useState } from 'react';
import '../../css/modals/SimpleModal.css';
import { IoClose } from 'react-icons/io5';

function SimpleModal({ close, handlerClose, handleCloseModal, url, plan }) {
	return (
		<div className={`Inscriptions ${close ? 'close' : ''}`} onClick={handleCloseModal}>
			<div className={`Inscriptions-content-simple ${close ? 'close' : ''}`}>
				<button
					className='Inscriptions-close-btn'
					onClick={() => {
						handlerClose();
					}}
				>
					<IoClose />
				</button>

				<div className='container-info'>
					<div className='container-title'>
						<h2>¡Advertencia!</h2>
					</div>
					{plan[0]?.type === 'presencial' ? (
						<p>
							Envía el comprobante de pago a
							<b>
								{' '}
								<u>coordinacion@libeluniversity.org</u>{' '}
							</b>
							para recibir el acceso al máster.{' '}
						</p>
					) : (
						<p>
							Envía el comprobante de pago a
							<b>
								{' '}
								<u>coordinacion@libeluniversity.org</u>{' '}
							</b>
							para recibir el formulario de registro. Este paso es esencial para asistir al taller.{' '}
							<b>Si eres de Colombia</b> y deseas inscribirte en nuestro taller, por favor
							contáctanos por <b>WhatsApp</b> para completar tu pago. El botón de inscripción solo
							está habilitado para pagos desde el exterior.
						</p>
					)}

					{/* <span> ¿Algún asesor te ayudó a realizar esta compra? </span> */}
				</div>
				<div className='btn-container-simple'>
					<a
						href={url ? url : null}
						// target='_blank'
						className='btn-camb-simple'
						onClick={() =>
							setTimeout(() => {
								handlerClose();
							}, 2000)
						}
					>
						{/* Ninguno */}
						Continuar con la compra
					</a>
					{/* <a
						href={'https://wa.link/wfk6xd'}
						target='_blank'
						className='btn-camb-simple'
						onClick={() =>
							setTimeout(() => {
								handlerClose();
							}, 2000)
						}
					>
						Viviana
					</a>
					<a
						href={'https://wa.link/lmycu1'}
						target='_blank'
						className='btn-camb-simple'
						onClick={() =>
							setTimeout(() => {
								handlerClose();
							}, 2000)
						}
					>
						Andrés
					</a> */}
					{/* <a
						href={url?.Camila}
						target='_blank'
						className='btn-camb-simple'
						onClick={() =>
							setTimeout(() => {
								handlerClose();
							}, 2000)
						}
					>
						Camila
					</a> */}
				</div>

				{/* <div className='container-info'>
					<p style={{ marginBottom: '24px' }}>
						Si tu asesor no aparece en las opciones o no tuviste asesor, selecciona
						<b>"Ninguno".</b>
					</p>
				</div> */}
			</div>
		</div>
	);
}

export default SimpleModal;
